import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export const GROUP_LABEL = 'text-micro font-medium tracking-group text-faint';

export const GroupLabel = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => <p className={cn('mb-label', GROUP_LABEL, className)}>{children}</p>;
